import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, CalendarCheck, Users, Phone, StickyNote, Check, X, CheckCheck } from "lucide-react";

const STATUS = {
  pending: { label: "In attesa", cls: "bg-amber-100 text-amber-700" },
  confirmed: { label: "Confermata", cls: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Rifiutata", cls: "bg-red-100 text-red-700" },
  handled: { label: "Gestita", cls: "bg-blue-100 text-blue-700" },
};

const BookingsPage = () => {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("all");

  const load = useCallback(() => { api.get("/bookings").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (b, status) => {
    try { await api.put(`/bookings/${b.id}`, { status }); toast.success("Aggiornata"); load(); }
    catch (e) { toast.error("Errore"); }
  };

  if (!rows) return <p className="text-muted-foreground flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</p>;
  const list = filter === "all" ? rows : rows.filter((r) => r.status === filter);

  return (
    <div className="space-y-6" data-testid="bookings-page">
      <div>
        <h1 className="font-cabinet font-bold text-3xl tracking-tight">Prenotazioni</h1>
        <p className="text-muted-foreground text-sm mt-1">Richieste ricevute dal tuo sito vetrina.</p>
      </div>
      <div className="flex gap-2 flex-wrap">
        {["all", "pending", "confirmed", "handled", "rejected"].map((k) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`bookings-filter-${k}`} className={`rounded-full px-4 py-1.5 text-sm font-semibold border ${filter === k ? "bg-[#002FA7] text-white border-[#002FA7]" : "border-border text-muted-foreground hover:border-[#002FA7]"}`}>{k === "all" ? "Tutte" : STATUS[k].label}</button>
        ))}
      </div>
      {list.length === 0 ? (
        <div className="bg-white rounded-2xl border border-border p-10 text-center text-muted-foreground text-sm">Nessuna prenotazione.</div>
      ) : (
        <div className="space-y-3">
          {list.map((b) => (
            <div key={b.id} className="bg-white rounded-2xl border border-border p-4" data-testid={`booking-${b.id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="font-semibold flex items-center gap-1.5"><CalendarCheck className="w-4 h-4 text-[#002FA7]" /> {b.name}</p>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${STATUS[b.status]?.cls || ""}`}>{STATUS[b.status]?.label || b.status}</span>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground mt-2 flex-wrap">
                    <span className="inline-flex items-center gap-1"><CalendarCheck className="w-3.5 h-3.5" /> {b.date || "—"} · {b.time || "—"}</span>
                    <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {b.people} pers.</span>
                    <span className="inline-flex items-center gap-1"><Phone className="w-3.5 h-3.5" /> {b.contact}</span>
                  </div>
                  {b.notes && <p className="text-sm mt-2 flex items-start gap-1.5 text-muted-foreground"><StickyNote className="w-3.5 h-3.5 mt-0.5" /> {b.notes}</p>}
                </div>
                <div className="flex gap-2 flex-wrap">
                  <button onClick={() => setStatus(b, "confirmed")} data-testid={`booking-confirm-${b.id}`} className="rounded-lg bg-emerald-600 text-white px-3 py-2 text-xs font-semibold hover:bg-emerald-700 flex items-center gap-1.5"><Check className="w-3.5 h-3.5" /> Conferma</button>
                  <button onClick={() => setStatus(b, "handled")} data-testid={`booking-handle-${b.id}`} className="rounded-lg border border-blue-500 text-blue-600 px-3 py-2 text-xs font-semibold hover:bg-blue-50 flex items-center gap-1.5"><CheckCheck className="w-3.5 h-3.5" /> Gestita</button>
                  <button onClick={() => setStatus(b, "rejected")} data-testid={`booking-reject-${b.id}`} className="rounded-lg border border-red-500 text-red-600 px-3 py-2 text-xs font-semibold hover:bg-red-50 flex items-center gap-1.5"><X className="w-3.5 h-3.5" /> Rifiuta</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingsPage;
